import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';
import NProgress from 'nprogress';
const LRUCache = require("lru-cache")


// const baseDomain = process.env.VUE_APP_DOMAIN;
//const baseURL = 'http://www.yokeserver.com/ekdipa-api';
const baseURL = process.env.VUE_APP_API_DOMAIN;

var tenMins = 10 * 60 * 60 * 1000


const cacheConfig = {
    enabledByDefault: true, 
    cacheFlag: 'useCache',
    defaultCache: new LRUCache({ maxAge: tenMins, max: 100 })
}


// const throttleConfig = {
//     threshold: 5 * 60 * 60 * 1000 // 5 mins
// }

const instance = axios.create({
	baseURL,
	auth: {
	  username: process.env.VUE_APP_API_USERNAME,
	  password: process.env.VUE_APP_API_PASS
	},
  // adapter: throttleAdapterEnhancer(axios.defaults.adapter, throttleConfig),
  headers: {
        'Cache-Control': 'no-cache'
    },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig)
})

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  NProgress.done()
  return response
},
function (error) {
  NProgress.done()
  return error.response
})

export default instance
